import { motion } from "framer-motion";
import { HeartHandshake, HandHeart, Wheat, Sun } from "lucide-react";

const PILLARS = [
  {
    icon: HeartHandshake,
    hindi: "सबको प्रेम करो",
    title: "Love Everyone",
    text: "Baba's first and only commandment. He saw no strangers — only God wearing different faces. 'Love everyone and tell the truth,' he would say, and meant every person, without exception.",
  },
  {
    icon: HandHeart,
    hindi: "सबकी सेवा करो",
    title: "Serve Everyone",
    text: "Service was Maharaj-ji's worship. To serve another being is to serve the Divine in them — no task too small, no person beneath care.",
  },
  {
    icon: Wheat,
    hindi: "सबको भोजन कराओ",
    title: "Feed Everyone",
    text: "No one left Baba's presence hungry. The bhandara — the free feast — is his living tradition, and we continue it in Denison every week. 'To feed people is to serve God.'",
  },
  {
    icon: Sun,
    hindi: "ईश्वर को याद करो",
    title: "Remember God",
    text: "Baba constantly repeated the name of Ram. Remember God in all you do, he taught, and the whole of life becomes prayer.",
  },
];

export default function BabaTeachings() {
  return (
    <section id="teachings" data-testid="teachings-section" className="py-20 sm:py-28 bg-[#F5F0E6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="eyebrow mb-4">04 · His Message</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-amber-950" data-testid="teachings-heading">
            Four Simple Doors to the Divine
          </h2>
          <p className="mt-5 text-stone-600 leading-relaxed">
            Maharaj-ji's entire teaching fits in a single breath. Four invitations, offered to everyone,
            everywhere, always.
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PILLARS.map((p, i) => (
            <motion.div key={p.title}
              initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.12 }}
              data-testid={`teaching-card-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative bg-[#FDFBF7] rounded-2xl border border-amber-900/10 p-7 hover:border-amber-600/40 hover:shadow-xl hover:shadow-amber-900/10 hover:-translate-y-1.5 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-full bg-gradient-to-b from-amber-100 to-orange-100 border border-amber-900/10 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                <p.icon className="h-6 w-6 text-orange-700" />
              </div>
              <p className="text-sm text-amber-700 font-medium tracking-wide">{p.hindi}</p>
              <h3 className="font-display text-xl text-amber-950 mt-1.5">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-stone-600">{p.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="mt-16 rounded-3xl bg-gradient-to-r from-amber-800 via-orange-800 to-amber-900 px-8 py-12 sm:px-14 text-center relative overflow-hidden"
          data-testid="sub-ek-banner"
        >
          <div className="absolute inset-0 opacity-10"
            style={{ backgroundImage: "radial-gradient(circle at 30% 50%, #FBBF24 0%, transparent 50%)" }} />
          <p className="relative font-quote italic text-2xl sm:text-3xl text-amber-50 leading-snug max-w-3xl mx-auto">
            "The whole universe is our home and all residing in it are our family…
            instead of trying to see God in a particular appearance, it is better to see Him in everything."
          </p>
          <p className="relative mt-5 text-xs uppercase tracking-[0.3em] text-amber-300 font-semibold">
            Sub Ek — All is One
          </p>
        </motion.div>
      </div>
    </section>
  );
}
